<template>
  <div>
    <Toolbar />
    <v-layout class="d-flex flex-column ma-0 pa-0 mt-md-5 mt-lg-5 mt-xl-5 px-5">
      <IconoHeader icono="lock" />
      <v-row justify="center" class="ma-0 pa-0 mt-5">
        <v-col cols="12" class="ma-0 pa-0">
          <h3 class="texto-titulo text-center font-weight-bold">
            Activa tu acceso a banca en línea
          </h3>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-5">
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="10"
          lg="10"
          xl="10"
          class="ma-0 pa-0"
        >
          <p
            class="text-body-2 text-center ma-0 pa-0 grey--text text--darken-2"
          >
            Define una contraseña que será necesaria para que ingreses a la app
            de CMV Finanzas (banca en línea).
            <span class="font-weight-bold"
              >¡Donde depositaremos tu dinero!</span
            >
          </p>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="10"
          lg="10"
          xl="10"
          class="ma-0 pa-0"
        >
          <v-card class="mt-5 mx-4 px-4 py-1 rounded-lg" elevation="2">
            <v-list-item>
              <v-list-item-content
                class="text-body-2 grey--text text--darken-2"
              >
                <v-list-item-title class="font-weight-bold">
                  Debe contener: <br />
                </v-list-item-title>
                <v-list-item-title> 8 caracteres </v-list-item-title>
                <v-list-item-title>
                  Al menos una letra mayúscula<br />
                </v-list-item-title>
                <v-list-item-title>
                  Al menos una letra minúscula<br />
                </v-list-item-title>
                <v-list-item-title> Al menos un número </v-list-item-title>
                <v-list-item-title>
                  Al menos un carácter especial,
                </v-list-item-title>
                <v-list-item-title>
                  Ejemplos: #,?,!,@,$,%,^,&,*,-
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container>
              <v-row justify="center" class="ma-0 pa-0">
                <v-col cols="12" xs="12" sm="12" md="10" lg="10" xl="10">
                  <v-text-field
                    outlined
                    :append-icon="mostrarContrasena ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="mostrarContrasena ? 'text' : 'password'"
                    @click:append="mostrarContrasena = !mostrarContrasena"
                    v-model="contrasena"
                    label="Contraseña"
                    required
                    placeholder="Ingresa una contraseña segura"
                    :error-messages="contrasenaErrors"
                    @input="$v.contrasena.$touch()"
                    @blur="$v.contrasena.$touch()"
                    hide-details="auto"
                    maxlength="8"
                    tabindex="1"
                  >
                  </v-text-field>
                  <v-text-field
                    outlined
                    :append-icon="
                      mostrarConfirmaContrasena ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    :type="mostrarConfirmaContrasena ? 'text' : 'password'"
                    @click:append="
                      mostrarConfirmaContrasena = !mostrarConfirmaContrasena
                    "
                    v-model="confirmaContrasena"
                    label="Confirmar contraseña"
                    required
                    placeholder="Confirma tu contraseña"
                    :error-messages="confirmaContrasenaErrors"
                    @input="$v.confirmaContrasena.$touch()"
                    @blur="$v.confirmaContrasena.$touch()"
                    class="mt-5"
                    hide-details="auto"
                    maxlength="8"
                    tabindex="2"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-4">
        <v-col
          cols="12"
          class="ma-0 pa-0 d-flex flex-row justify-center align-center"
        >
          <v-btn
            class="align-self-center"
            color="primary"
            elevation="2"
            type="submit"
            :disabled="!valid"
            @click="submit"
            >CONTINUAR<v-icon right light>mdi-arrow-right</v-icon></v-btn
          >
        </v-col>
      </v-row>
    </v-layout>
  </div>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import IconoHeader from '@/components/compartidos/IconoHeader.vue'
import { validationMixin } from 'vuelidate'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

import {
  required,
  minLength,
  maxLength,
  sameAs,
} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin, InsertaLogMixin],
  components: {
    Toolbar,
    IconoHeader,
  },
  name: 'ContrasenaCMVF',
  data: () => ({
    allowSpaces: false,
    match: 'Foobar',
    max: 0,
    model: 'Foobar',
    contrasena: '',
    confirmaContrasena: '',
    valid: false,
    maxLength: 8,
    mostrarContrasena: false,
    mostrarConfirmaContrasena: false,
  }),

  validations: {
    contrasena: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(8),
      containsUppercase: function (value) {
        return /[A-Z]/.test(value)
      },
      containsLowercase: function (value) {
        return /[a-z]/.test(value)
      },
      containsNumber: function (value) {
        return /[0-9]/.test(value)
      },
      containsSpecial: function (value) {
        return /[#?!@$%^&*-]/.test(value)
      },
      containsSpace: function (value) {
        return /^\S*$/.test(value)
      },
    },
    confirmaContrasena: {
      required,
      minLength: minLength(8),
      sameAs: sameAs('contrasena'),
    },
  },
  computed: {
    contrasenaErrors() {
      const errors = []
      if (!this.$v.contrasena.$dirty) return errors
      !this.$v.contrasena.minLength &&
        errors.push('La contraseña debe ser de 8 caracteres')
      !this.$v.contrasena.maxLength &&
        errors.push('La contraseña debe ser de 8 caracteres')
      !this.$v.contrasena.required && errors.push('La contraseña es requerida.')
      !this.$v.contrasena.containsUppercase &&
        errors.push('La contraseña debe contener al menos 1 mayúscula')
      !this.$v.contrasena.containsLowercase &&
        errors.push('La contraseña debe contener al menos 1 minúscula')
      !this.$v.contrasena.containsNumber &&
        errors.push('La contraseña debe contener al menos 1 número')
      !this.$v.contrasena.containsSpace &&
        errors.push('La contraseña no debe contener espacios')
      !this.$v.contrasena.containsSpecial &&
        errors.push('La contraseña debe contener al menos un carácter especial')
      // this.$gtag.event('correoErrors', {
      //   event_category: 'change_in_window',
      //   event_label: 'No fue valido la contraseña',
      //   value: errors[0],
      // })
      return errors
    },
    confirmaContrasenaErrors() {
      const errors = []
      if (!this.$v.confirmaContrasena.$dirty) return errors
      !this.$v.confirmaContrasena.sameAs &&
        errors.push('Las contraseñas deben coincidir')
      !this.$v.confirmaContrasena.required &&
        errors.push('La confirmación es requerida')
      // this.$gtag.event('correoErrors', {
      //   event_category: 'change_in_window',
      //   event_label: 'No fue valido la contraseña',
      //   value: errors[0],
      // })
      return errors
    },
  },
  mounted() {
    this.InsertaLog()
  },
  created() {
    this.$store.getters['persona/obtenerPersona'].bancaActiva == 1
      ? this.$router.push('confirmacion')
      : this.$store.getters['credito/obtenerCredito'].tipoCredito == 245
      ? this.$router.push('referencia')
      : ''
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch('persona/establecerContrasena', this.contrasena)
        this.$store.getters['credito/obtenerCredito'].tipoCredito == 245
          ? this.$router.push('referencia')
          : this.$router.push('confirmacion')
      }
    },
    clear() {
      this.$v.$reset()
    },
  },
}
</script>
